// extracted by mini-css-extract-plugin
export default {"banner":"BetaFeedbackCard_banner__eTUqj"};